import React from 'react';
import {useIntl} from 'react-intl';
import {Formik} from 'formik';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {useCustomersForProjectsUIContext} from '../CustomersForProjectsUIContext';
import {RequestCancellationManager} from '../../../_common/utils/RequestCancellationManager';
import * as actions from '../../_redux/projectsActions';

export const FieldSearchCustomer = () => {
  const intl = useIntl();
  const label = intl.formatMessage({
    id: 'projects-popup-search-customer-label', defaultMessage: 'Search customer'
  });
  const {text, setText} = useCustomersForProjectsUIContext();

  return (
    <Formik
      initialValues={{text}}
      onSubmit={() => {}}
      enableReinitialize={true}
    >
      {({
          values,
          handleSubmit,
          handleBlur,
          setFieldValue
        }) => (
        <form onSubmit={handleSubmit} className={'mb-2'}>
          <div className={'position-relative'}>
            <input
              className={'form-control custom-data-item'}
              name={'text'}
              placeholder={label}
              onBlur={handleBlur}
              value={values.text}
              onChange={(e) => {
                setFieldValue('text', e.target.value);
                setText(e.target.value);
                RequestCancellationManager.stopRequests(actions.getCustomersForProjectsIDPrefix);
              }}
            />
            <img
              src={toAbsoluteUrl('/media/svg/Cross_brandColor.svg')}
              alt="clear-filter"
              style={{
                position: 'absolute',
                top: '2px',
                left: '3px',
                cursor: 'pointer'
              }}
              onClick={() => {
                setFieldValue('text', '');
                setText('');
                RequestCancellationManager.stopRequests(actions.getCustomersForProjectsIDPrefix);
              }}
            />
          </div>
        </form>
      )}
    </Formik>
  );
};
